export default "__VITE_ASSET__G8mFr2lj__"